export const PAYMENT_TYPE = {
  EXPIRY: "expiry",
  SUBSCRIPTION: "subscription",
};
